/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ExportClearanceCaseResult {
  Success = 0,
  Error = 1,
  SaveFailed = 2,
  ValidationFailed = 3,
  NotFound = 404,
}
